/* ═══════════════════════════════════════════════════════════
   lux-product-page.js
   Upload to: assets/lux-product-page.js
   Pure JS — zero Liquid. All dynamic data is passed in via
   LuxPage.init(config) called from lux-scripts-init.liquid
═══════════════════════════════════════════════════════════ */

var LuxPage = {

  init: function(config) {
    'use strict';

    var SID             = config.sectionId;
    var variantData     = config.variants        || [];
    var selectedOptions = config.selectedOptions || [];
    var moneyFormat     = config.moneyFormat     || '${{amount}}';
    var atcText         = config.atcText         || 'Add to Cart';
    var pincodeError    = config.pincodeError    || 'Please enter a valid 6-digit pincode.';
    var pincodeBtnText  = config.pincodeBtnText  || 'Check';
    var deliveryOk      = config.deliveryOk      || 'Delivery available!';
    var productFormId   = config.productFormId;
    var showPopup       = config.showPopup;
    var popupDelay      = config.popupDelay      || 5;
    var popupInterval   = config.popupInterval   || 20;
    var popupData       = config.popupData       || [];

    /* ══════════════════════════════════════
       HELPERS
    ══════════════════════════════════════ */
    function $$(selector, context) {
      return Array.prototype.slice.call((context || document).querySelectorAll(selector));
    }
    function $(selector, context) {
      return (context || document).querySelector(selector);
    }
    /* Section-scoped selectors */
    function $s(selector) { return $('#shopify-section-' + SID + ' ' + selector); }
    function $$s(selector) { return $$('#shopify-section-' + SID + ' ' + selector); }

    /* ══════════════════════════════════════
       SCROLL ANIMATIONS
    ══════════════════════════════════════ */
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      var animObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            animObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      $$('#lux-page-' + SID + ' .lux-fade-up, ' +
         '#lux-page-' + SID + ' .lux-fade-in, ' +
         '#lux-page-' + SID + ' .lux-scale-in').forEach(function(el) {
        animObs.observe(el);
      });
    } else {
      $$('.lux-fade-up, .lux-fade-in, .lux-scale-in').forEach(function(el) {
        el.classList.add('is-visible');
      });
    }

    /* ══════════════════════════════════════
       GALLERY
    ══════════════════════════════════════ */
    var gallery = document.getElementById('lux-gallery-' + SID);

    /* Guard: if no gallery on page, skip gallery logic but continue rest */
    var thumbs = gallery ? gallery.querySelectorAll('.lux-thumb') : [];
    var slides = gallery ? gallery.querySelectorAll('.lux-gallery-slide') : [];
    var dots   = gallery ? gallery.querySelectorAll('.lux-gallery-dot') : [];
    var mainEl = document.getElementById('lux-main-' + SID);

    var currentSlideIndex = 0;

    function goToSlide(index) {
      if (!slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index));
      currentSlideIndex = index;

      Array.prototype.forEach.call(slides, function(s, i) {
        s.classList.toggle('active', i === index);
      });
      Array.prototype.forEach.call(thumbs, function(t, i) {
        t.classList.toggle('active', i === index);
      });
      Array.prototype.forEach.call(dots, function(d, i) {
        d.classList.toggle('active', i === index);
      });
    }

    /* Ensure first slide/thumb/dot is active on load */
    goToSlide(0);

    Array.prototype.forEach.call(thumbs, function(t) {
      t.addEventListener('click', function() {
        var idx = parseInt(t.dataset.index, 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    });

    Array.prototype.forEach.call(dots, function(d) {
      d.addEventListener('click', function() {
        var idx = parseInt(d.dataset.index, 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    });

    /* Mobile swipe */
    var touchStartX = 0;
    var touchStartY = 0;
    if (mainEl) {
      mainEl.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      mainEl.addEventListener('touchend', function(e) {
        var diffX = touchStartX - e.changedTouches[0].clientX;
        var diffY = touchStartY - e.changedTouches[0].clientY;

        /* Only treat as horizontal swipe if X movement dominates */
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX > 0) {
            goToSlide(Math.min(currentSlideIndex + 1, slides.length - 1));
          } else {
            goToSlide(Math.max(currentSlideIndex - 1, 0));
          }
        }
      });
    }

    /* Keyboard navigation for gallery */
    document.addEventListener('keydown', function(e) {
      if (document.activeElement && document.activeElement.closest &&
          document.activeElement.closest('#lux-gallery-' + SID)) {
        if (e.key === 'ArrowLeft')  goToSlide(currentSlideIndex - 1);
        if (e.key === 'ArrowRight') goToSlide(currentSlideIndex + 1);
      }
    });

    /* Zoom overlay */
    var zoomOverlay = document.createElement('div');
    zoomOverlay.className = 'lux-zoom-overlay';
    zoomOverlay.setAttribute('role', 'dialog');
    zoomOverlay.setAttribute('aria-modal', 'true');
    zoomOverlay.setAttribute('aria-label', 'Zoomed product image');
    var zoomImg = document.createElement('img');
    zoomImg.setAttribute('alt', '');
    zoomOverlay.appendChild(zoomImg);
    document.body.appendChild(zoomOverlay);

    function openZoom() {
      var activeImg = gallery && gallery.querySelector('.lux-gallery-slide.active img');
      if (!activeImg) return;
      /* Replace Shopify size param to get larger image */
      var src = activeImg.src
        .replace(/width=\d+/, 'width=1600')
        .replace(/_\d+x(\d+)?\./, '.');
      zoomImg.src = src;
      zoomImg.alt = activeImg.alt;
      zoomOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeZoom() {
      zoomOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (mainEl) {
      mainEl.addEventListener('click', openZoom);
    }
    zoomOverlay.addEventListener('click', closeZoom);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && zoomOverlay.classList.contains('active')) closeZoom();
    });

    /* ══════════════════════════════════════
       QUANTITY
    ══════════════════════════════════════ */
    var qtyInput  = document.getElementById('lux-qty-' + SID);
    var qtyHidden = document.getElementById('lux-qty-hidden-' + SID);
    var qtyMinus  = document.getElementById('lux-qty-minus-' + SID);
    var qtyPlus   = document.getElementById('lux-qty-plus-' + SID);

    function updateQty(val) {
      val = Math.max(1, Math.min(99, parseInt(val, 10) || 1));
      if (qtyInput)  qtyInput.value  = val;
      if (qtyHidden) qtyHidden.value = val;
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        updateQty((parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) - 1);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        updateQty((parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) + 1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        updateQty(qtyInput.value);
      });
      qtyInput.addEventListener('blur', function() {
        updateQty(qtyInput.value);
      });
    }

    /* ══════════════════════════════════════
       MONEY FORMAT HELPER
    ══════════════════════════════════════ */
    function formatMoney(cents, format) {
      /* Use Shopify's helper if available, otherwise roll our own */
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, format);
      }
      /* Minimal fallback */
      var amount = (cents / 100).toFixed(2);
      return format
        ? format.replace('{{amount}}', amount)
            .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        : '₹' + amount;
    }

    /* ══════════════════════════════════════
       VARIANT SELECTION
    ══════════════════════════════════════ */
    function findVariant() {
      if (!variantData.length) return null;
      return variantData.find(function(v) {
        if (!v.options || !v.options.length) return false;
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      }) || null;
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;

      var priceEl   = document.getElementById('lux-price-' + SID);
      var atcBtn    = document.getElementById('lux-atc-' + SID);
      var atcTextEl = document.getElementById('lux-atc-text-' + SID);
      var buyNowBtn = document.getElementById('lux-buynow-' + SID);
      var dcoWrap   = document.getElementById('lux-dco-' + SID);
      var varId     = document.getElementById('lux-variant-id-' + SID);

      if (varId) varId.value = variant.id;

      /* ── Price ── */
      if (priceEl) {
        var priceFormatted = formatMoney(variant.price, moneyFormat);
        var compareHTML = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var compareFormatted = formatMoney(variant.compare_at_price, moneyFormat);
          var discount = Math.round(
            (variant.compare_at_price - variant.price) / variant.compare_at_price * 100
          );
          compareHTML =
            '<span class="lux-compare-price">' + compareFormatted + '</span>' +
            '<span class="lux-discount-badge">' + discount + '% OFF</span>';
        }
        priceEl.innerHTML =
          '<span class="lux-price">' + priceFormatted + '</span>' + compareHTML;
      }

      /* ── ATC button state ── */
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('lux-btn-soldout');
          atcBtn.setAttribute('aria-label', 'Add to cart');
          if (atcTextEl) atcTextEl.textContent = atcText;

          var icon = atcBtn.querySelector('.lux-atc-icon');
          if (icon) {
            icon.innerHTML =
              '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
              '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>';
          }
        } else {
          atcBtn.disabled = true;
          atcBtn.classList.add('lux-btn-soldout');
          atcBtn.setAttribute('aria-label', 'Sold out');
          if (atcTextEl) atcTextEl.textContent = 'Sold Out';

          var icon2 = atcBtn.querySelector('.lux-atc-icon');
          if (icon2) {
            icon2.innerHTML =
              '<circle cx="12" cy="12" r="10"/>' +
              '<line x1="15" y1="9" x2="9" y2="15"/>' +
              '<line x1="9" y1="9" x2="15" y2="15"/>';
          }
        }
      }

      /* ── Buy Now + DCO visibility ── */
      if (buyNowBtn) buyNowBtn.style.display = variant.available ? '' : 'none';
      if (dcoWrap)   dcoWrap.style.display   = variant.available ? '' : 'none';

      /* ── Image sync: jump gallery to variant image ── */
      if (variant.featured_image && variant.featured_image.src) {
        var variantSrc = variant.featured_image.src.split('?')[0].toLowerCase();
        var imgHandle  = variantSrc.split('/').pop().replace(/\.[^.]+$/, '');
        var matched    = false;

        Array.prototype.forEach.call(slides, function(slide, i) {
          if (matched) return;
          var img = slide.querySelector('img');
          if (img) {
            var imgSrc = img.getAttribute('src') || img.getAttribute('data-src') || '';
            var normalised = imgSrc.split('?')[0].toLowerCase();
            if (normalised.indexOf(imgHandle) !== -1) {
              goToSlide(i);
              matched = true;
            }
          }
        });
      }

      /* ── Sticky ATC price ── */
      var stickyPrice = document.getElementById('lux-sticky-price-' + SID);
      if (stickyPrice && variant.price) {
        stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
      }
    }

    /* Bind variant buttons & swatches */
    $$s('.lux-swatch, .lux-variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.classList.contains('sold-out')) return;

        var optionWrap = btn.closest('[data-option-index]');
        if (!optionWrap) return;

        var optIdx = parseInt(optionWrap.dataset.optionIndex, 10);
        if (isNaN(optIdx)) return;

        selectedOptions[optIdx] = btn.dataset.value;

        /* Update active state within this option group only */
        Array.prototype.forEach.call(
          optionWrap.querySelectorAll('.lux-swatch, .lux-variant-btn'),
          function(b) { b.classList.remove('active'); }
        );
        btn.classList.add('active');

        /* Update selected label */
        var selectedLabel = document.getElementById('lux-selected-' + SID + '-' + optIdx);
        if (selectedLabel) selectedLabel.textContent = btn.dataset.value;

        updateVariant();
      });
    });

    /* Run once on init to sync price/button with default variant */
    updateVariant();

    /* ══════════════════════════════════════
       ACCORDIONS
    ══════════════════════════════════════ */
    $$s('.lux-accordion-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var accordion = btn.closest('.lux-accordion');
        if (!accordion) return;
        var body   = accordion.querySelector('.lux-accordion-body');
        var isOpen = accordion.classList.contains('open');

        /* Close all siblings first */
        $$s('.lux-accordion.open').forEach(function(a) {
          a.classList.remove('open');
          var b = a.querySelector('.lux-accordion-body');
          if (b) b.style.maxHeight = '0';
          var ab = a.querySelector('.lux-accordion-btn');
          if (ab) ab.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          accordion.classList.add('open');
          if (body) body.style.maxHeight = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ══════════════════════════════════════
       DELIVERY CHECKER
    ══════════════════════════════════════ */
    var pincodeBtn     = document.getElementById('lux-pincode-btn-' + SID);
    var pincodeInput   = document.getElementById('lux-pincode-' + SID);
    var deliveryResult = document.getElementById('lux-delivery-result-' + SID);

    if (pincodeBtn && pincodeInput && deliveryResult) {
      function checkPincode() {
        var pin = pincodeInput.value.trim();
        if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
          deliveryResult.className = 'lux-delivery-result error';
          deliveryResult.textContent = pincodeError;
          return;
        }
        pincodeBtn.textContent = '...';
        pincodeBtn.disabled = true;
        setTimeout(function() {
          pincodeBtn.textContent = pincodeBtnText;
          pincodeBtn.disabled = false;
          deliveryResult.className = 'lux-delivery-result success';
          deliveryResult.innerHTML = '✓ ' + deliveryOk;
        }, 800);
      }

      pincodeBtn.addEventListener('click', checkPincode);
      pincodeInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') checkPincode();
      });
    }

    /* ══════════════════════════════════════
       WISHLIST TOGGLE
    ══════════════════════════════════════ */
    var wishlistBtn = document.getElementById('lux-wishlist-' + SID);
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function() {
        wishlistBtn.classList.toggle('active');
        var isActive = wishlistBtn.classList.contains('active');
        wishlistBtn.setAttribute('aria-label',
          isActive ? 'Remove from wishlist' : 'Add to wishlist'
        );
        /* Optional: persist to localStorage */
        try {
          var productHandle = wishlistBtn.dataset.productHandle || '';
          if (productHandle) {
            var wishlist = JSON.parse(localStorage.getItem('lux_wishlist') || '[]');
            if (isActive) {
              if (wishlist.indexOf(productHandle) === -1) wishlist.push(productHandle);
            } else {
              wishlist = wishlist.filter(function(h) { return h !== productHandle; });
            }
            localStorage.setItem('lux_wishlist', JSON.stringify(wishlist));
          }
        } catch (e) { /* localStorage may be unavailable */ }
      });

      /* Restore wishlist state on load */
      try {
        var productHandle = wishlistBtn.dataset.productHandle || '';
        if (productHandle) {
          var savedWishlist = JSON.parse(localStorage.getItem('lux_wishlist') || '[]');
          if (savedWishlist.indexOf(productHandle) !== -1) {
            wishlistBtn.classList.add('active');
          }
        }
      } catch (e) {}
    }

    /* ══════════════════════════════════════
       CART UTILITIES
    ══════════════════════════════════════ */
    function refreshCartCount() {
      fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var count = cart.item_count || 0;

          /* Cover the widest range of theme cart count selectors */
          var selectors = [
            '[data-cart-count]',
            '.cart-count',
            '.cart__count',
            '.header__cart-count',
            '.cart-count-bubble',
            '.icon-cart__badge',
            '#cart-count',
            '#CartCount',
            '.cart-item-count',
            '[data-cart-item-count]'
          ];
          $$(selectors.join(', ')).forEach(function(el) {
            el.textContent = count;
            el.style.display = count > 0 ? '' : 'none';
          });

          /* Dawn-specific bubble spans */
          $$('cart-icon-bubble .cart-count-bubble span:first-child, ' +
             '.cart-count-bubble span[aria-hidden]').forEach(function(b) {
            b.textContent = count;
          });
        })
        .catch(function() {});
    }

    function openCartDrawer() {
  refreshCartCount();

  var cartDrawer = document.querySelector('cart-drawer-component');
  if (!cartDrawer) return;

  fetch('/cart?sections=cart-drawer')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data['cart-drawer']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var newDrawer = tmp.querySelector('cart-drawer-component');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        } else {
          cartDrawer.innerHTML = tmp.innerHTML;
        }
      }

      /* Open after content update */
      cartDrawer.setAttribute('auto-open', 'true');
      if (typeof cartDrawer.open === 'function') {
        try { cartDrawer.open(); } catch(e) {}
      }
      cartDrawer.dispatchEvent(new CustomEvent('cart-drawer-component/open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-drawer-component/open', { bubbles: true }));
    })
    .catch(function() {
      /* Fallback - open without refresh */
      cartDrawer.setAttribute('auto-open', 'true');
      if (typeof cartDrawer.open === 'function') {
        try { cartDrawer.open(); } catch(e) {}
      }
      cartDrawer.dispatchEvent(new CustomEvent('cart-drawer-component/open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-drawer-component/open', { bubbles: true }));
    });
}

    /* ══════════════════════════════════════
       BUY NOW
    ══════════════════════════════════════ */
    var buyNowBtn = document.getElementById('lux-buynow-' + SID);
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        var varId = document.getElementById('lux-variant-id-' + SID);
        var qty   = document.getElementById('lux-qty-hidden-' + SID);
        if (!varId || !varId.value) return;
        var quantity = (qty && qty.value) ? qty.value : '1';
        window.location.href = '/cart/' + varId.value + ':' + quantity + '?checkout';
      });
    }

    /* ══════════════════════════════════════
       QUICK ADD (Recommended products)
    ══════════════════════════════════════ */
    $$s('.lux-quick-add').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.dataset.productId || btn.dataset.variantId;
        if (!variantId) return;

        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Quick add failed');
            return res.json();
          })
          .then(function() {
            btn.textContent = '✓ Added';
            btn.style.background = '#2e7d32';
            btn.style.color = '#fff';
            refreshCartCount();
            openCartDrawer();
            setTimeout(function() {
              btn.textContent = originalText;
              btn.style.background = '';
              btn.style.color = '';
              btn.disabled = false;
            }, 2000);
          })
          .catch(function() {
            btn.textContent = 'Error';
            setTimeout(function() {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          });
      });
    });

    /* ══════════════════════════════════════
       STICKY ATC
    ══════════════════════════════════════ */
    var stickyAtc   = document.getElementById('lux-sticky-' + SID);
    var heroSection = $s('.lux-hero');
    var stickyBtn   = document.getElementById('lux-sticky-btn-' + SID);

    if (stickyAtc && heroSection) {
      var stickyObs = new IntersectionObserver(function(entries) {
        stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0.3 });
      stickyObs.observe(heroSection);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var mainAtcBtn = document.getElementById('lux-atc-' + SID);
        if (mainAtcBtn) mainAtcBtn.click();
      });
    }

    /* ══════════════════════════════════════
       RECENTLY PURCHASED POPUP
    ══════════════════════════════════════ */
    if (showPopup && popupData.length > 0) {
      var popupEl    = document.getElementById('lux-popup-' + SID);
      var popupClose = document.getElementById('lux-popup-close-' + SID);
      var popupName  = document.getElementById('lux-popup-name-' + SID);
      var popupInfo  = document.getElementById('lux-popup-info-' + SID);
      var popupTime  = document.getElementById('lux-popup-time-' + SID);
      var popupIdx   = 0;
      var popupDismissed = false;
      var popupTimer;

      function showNextPopup() {
        if (popupDismissed || !popupEl) return;
        var item = popupData[popupIdx % popupData.length];
        popupIdx++;

        if (popupName) popupName.textContent = item.name;
        if (popupInfo) popupInfo.textContent = 'from ' + item.city + ' purchased this';
        if (popupTime) popupTime.textContent = item.time;

        popupEl.classList.add('visible');

        clearTimeout(popupTimer);
        popupTimer = setTimeout(function() {
          if (popupEl) popupEl.classList.remove('visible');
        }, 4000);
      }

      var initialTimer = setTimeout(function() {
        showNextPopup();
        var intervalId = setInterval(function() {
          if (popupDismissed) {
            clearInterval(intervalId);
            return;
          }
          showNextPopup();
        }, popupInterval * 1000);
      }, popupDelay * 1000);

      if (popupClose) {
        popupClose.addEventListener('click', function() {
          if (popupEl) popupEl.classList.remove('visible');
          popupDismissed = true;
          clearTimeout(initialTimer);
          clearTimeout(popupTimer);
        });
      }
    }

    /* ══════════════════════════════════════
       LIFESTYLE PARALLAX
    ══════════════════════════════════════ */
    var lifestyleBg = document.getElementById('lux-lifestyle-bg-' + SID);
    if (lifestyleBg && !prefersReducedMotion) {
      var lifestyleSection = lifestyleBg.closest('.lux-lifestyle');
      var lTicking = false;

      window.addEventListener('scroll', function() {
        if (!lTicking) {
          requestAnimationFrame(function() {
            if (lifestyleSection) {
              var rect     = lifestyleSection.getBoundingClientRect();
              var inView   = rect.bottom > 0 && rect.top < window.innerHeight;
              if (inView) {
                var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
                var offset   = (progress - 0.5) * -40;
                lifestyleBg.style.transform = 'translateY(' + offset + 'px)';
              }
            }
            lTicking = false;
          });
          lTicking = true;
        }
      }, { passive: true });
    }

    /* ══════════════════════════════════════
       REVIEW BARS — animate on scroll
    ══════════════════════════════════════ */
    var reviewBars = $$s('.lux-review-bar-fill');
    if (reviewBars.length) {
      /* Store target widths then reset to 0 for animation */
      reviewBars.forEach(function(bar) {
        var target = bar.style.width || '0%';
        bar.dataset.targetWidth = target;
        bar.style.width = '0%';
      });

      var barObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var bar = entry.target;
            bar.style.width = bar.dataset.targetWidth || '0%';
            barObs.unobserve(bar);
          }
        });
      }, { threshold: 0.3 });

      reviewBars.forEach(function(bar) { barObs.observe(bar); });
    }

    /* ══════════════════════════════════════
       UGC MARQUEE — pause/resume on focus
    ══════════════════════════════════════ */
    var ugcTrack = $s('.lux-ugc-track');
    if (ugcTrack) {
      ugcTrack.addEventListener('mouseenter', function() {
        ugcTrack.style.animationPlayState = 'paused';
      });
      ugcTrack.addEventListener('mouseleave', function() {
        ugcTrack.style.animationPlayState = '';
      });
      /* Touch: pause on touchstart, resume after delay */
      ugcTrack.addEventListener('touchstart', function() {
        ugcTrack.style.animationPlayState = 'paused';
      }, { passive: true });
      ugcTrack.addEventListener('touchend', function() {
        setTimeout(function() {
          ugcTrack.style.animationPlayState = '';
        }, 2000);
      });
    }

  } /* end init */

}; /* end LuxPage */
